<template>
  <div class="row">
    <div class="col-12">
      <div id="accordionAirvolumes" class="accordion">
        <div v-for="(unit, index) in units" :key="index" class="row mb-2 align-items-center">
          <div class="col-auto pr-0">
            <button :aria-controls="'unit_' + index"
                    :data-target="'#unit_' + index" :disabled="unit.rooms.length <= 0" aria-expanded="false"
                    class="btn btn-block d-flex align-items-center text-left no-gutters collapsed"
                    data-toggle="collapse" role="button">
                            <span class="col-auto pr-3">
                                <svg class="icon m-0">
                                    <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                                         xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                </svg>
                            </span>
              <span class="col-auto">{{ unit.getSpecification(__) }}</span>
            </button>
          </div>
          <span v-if="!unit.checkSpace()" class="col-auto pl-0">
                        <a v-b-popover.hover.right="__('lang.kwl.room_overview.space_info')" role="button" tabindex="0">
                            <svg class="icon m-0 mb-1 text-primary">
                                <use xlink:href="/assets/img/icon-sprite.svg#global.warning"
                                     xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                            </svg>
                        </a>
                    </span>
          <span v-if="!checkMoisureProtection(unit)" class="col-auto pl-0">
                        <a v-b-popover.hover.right="__('lang.kwl.room_overview.fl_info')" role="button" tabindex="0">
                            <svg class="icon m-0 mb-1 text-primary">
                                <use xlink:href="/assets/img/icon-sprite.svg#global.warning"
                                     xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                            </svg>
                        </a>
                    </span>
          <hr class="w-100 my-0 mx-3"/>
          <div :id="'unit_' + index" :class="index == 0 ? 'show' : ''" class="collapse col-12"
               data-parent="#accordionAirvolumes">
            <div class="container-fluid">
              <div v-if="unit.rooms.length > 0 && unit.airvolume" class="row justify-content-end">
                <div class="col-12 pl-5 pr-0 mt-4">
                  <div v-if="unit.ventilationMeasure != 1 && configuration.norms_id!=2">
                    <UnitAirVolumeComponent :key="'unitAirCalc_' + index" :unitId="unit.id"></UnitAirVolumeComponent>
                  </div>
                  <div v-if="configuration.norms_id==1">
                    <RoomAirVolumeComponentDe :key="'roomAirCalc_' + index"
                                              :unitId="unit.id"></RoomAirVolumeComponentDe>
                  </div>
                  <div v-else>

                    <RoomAirVolumeComponentAt :key="'roomAirCalc_' + index"
                                              :unitId="unit.id"></RoomAirVolumeComponentAt>


                  </div>

                  <!--                  <RoomAirVolumeComponent :unitId="unit.id" :key="'roomAirCalc_' + index"></RoomAirVolumeComponent>-->
                  <DetailComponent :key="'airDetails_' + index" :unitId="unit.id"></DetailComponent>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Unit from "@models/building/Unit";

import log from "@services/logger/index";
import Configuration from "@models/project/Configuration";
import {devicePackageData} from "@services/helpers/initializationHandler";

export default {
  components: {
    UnitAirVolumeComponent: () => import("./UnitAirVolumeComponent"),
    // RoomAirVolumeComponent: () => import("./RoomAirVolumeComponent"),
    RoomAirVolumeComponentDe: () => import("./Partials/de/RoomAirVolumeComponent"),
    RoomAirVolumeComponentAt: () => import("./Partials/at/RoomAirVolumeComponent"),
    DetailComponent: () => import("./DetailComponent"),
  },
  data() {
    return {};
  },
  computed: {
    units() {
      return Unit.query().with(["rooms", "airvolume"]).get();
    },
    project: {
      get() {
        return this.$store.state.projectData.project;
      },
    },
    configuration() {
      return Configuration.query().with(['project']).first()
    },
  },
  methods: {
    checkMoisureProtection(unit) {
      return true;
      if (unit.ventilationMeasure != 1 || unit.ventilationMeasure != 7) return true;
      return unitAirvolumes.checkMoisureProtection(unit);
    },
  },
  async beforeCreate() {
    await devicePackageData()
    document.getElementsByTagName("body")[0].classList.remove("is-loading");
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>
